import { ShieldCheck, FileDown, ExternalLink, ArrowUp } from "lucide-react";
import { Logo } from "./Logo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PDF_URL = `${BACKEND_URL}/api/capability-statement.pdf`;

export default function Footer() {
  return (
    <footer className="bg-[#0D0F12] border-t border-slate-800 pb-[52px] lg:pb-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 md:py-16 grid sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12">
        <div>
          <div className="mb-5">
            <Logo markClass="h-11 w-11" id="footer-logo" testid="footer-logo" />
          </div>
          <p className="font-mono text-xs tracking-[0.15em] uppercase text-slate-300 mb-4" data-testid="footer-brand-line">
            DEFCOIN Ltd. <span className="text-slate-600">|</span> NCAGE Code: <span className="text-[#C9A24A]">01GUU</span>
          </p>
          <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
            EU-based, NATO-CAGE registered government contractor. Defense procurement, enterprise IT, and
            dual-use logistics across European operational theaters.
          </p>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-5">Contact &amp; Registry</p>
          <ul className="space-y-3 text-sm">
            <li className="text-slate-300" data-testid="footer-legal-entity">DEFCOIN Ltd.</li>
            <li className="text-slate-400" data-testid="footer-location">Sofia, Bulgaria — EU / NATO Eastern Flank</li>
            <li className="font-mono text-xs text-slate-400 leading-relaxed" data-testid="footer-registry-ids">
              UIC: 208073340 <span className="text-slate-600">|</span> VAT: BG208073340<br />
              NATO NCAGE: <span className="text-amber-500">01GUU</span> <span className="text-slate-600">|</span> UEI: <span className="text-amber-500">FJNKCGJV1QQ6</span>
            </li>
            <li>
              <a href="tel:+359876065815" className="inline-flex items-center min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-phone-link">
                +359 87 606 5815
              </a>
            </li>
            <li>
              <a href="mailto:contracts@def-coin.com" className="inline-flex items-center min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-email-link">
                contracts@def-coin.com
              </a>
            </li>
            <li className="text-slate-400">def-coin.com</li>
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-5">Documents & Registries</p>
          <ul className="space-y-1 sm:space-y-3 text-sm">
            <li>
              <a href={PDF_URL} download className="inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-capability-pdf-link">
                <FileDown className="w-4 h-4" /> Capability Statement (PDF)
              </a>
            </li>
            <li>
              <a href="https://sam.gov" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-samgov-link">
                <ExternalLink className="w-4 h-4" /> SAM.gov Profile
              </a>
            </li>
            <li>
              <a href="/admin" className="inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-admin-link">
                <ShieldCheck className="w-4 h-4" /> Enquiry Inbox (Admin)
              </a>
            </li>
            <li>
              <a href="#top" className="inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-slate-300 hover:text-amber-500 transition-colors" data-testid="footer-back-to-top-link">
                <ArrowUp className="w-4 h-4" /> Back to Top
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-slate-600 leading-relaxed" data-testid="footer-legal">
            © 2026 DEFCOIN Ltd. All Rights Reserved. NCAGE 01GUU · UEI FJNKCGJV1QQ6.
          </p>
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-slate-700">SOFIA // BG // NATO EASTERN FLANK</p>
        </div>
      </div>
    </footer>
  );
}
